module.exports = __webpack_public_path__ + "static/media/icon_billing.6f000321.svg";